import type { Translation } from 'primeng/api';

/** Pulse-specific overrides applied on top of primelocale `fr` for fr-CA builds. */
export const primengFrCaOverrides: Partial<Translation> = {
  dateFormat: 'mm/dd/yy'
};
